import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../Assets/logo.png';
import loading from '../Assets/loading.gif';
import { name, ApiEndpoint, platform } from "../Constant";
import Footer from "../Components/footer";
import Button from "../Components/button";
import * as axios from 'axios';
import { RedirectIfLogin, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";

class Reset extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : this.props.match.params.id,
      userToken : this.props.match.params.token,
      password: '',
      password2: '',
      isAuthenticated: '',
      message: '',
      loading: '',
      retry_times: 0,
    }
    }

    componentDidMount(){
      RedirectIfLogin();
      this.PreloadDatas();
    }

    componentDidUpdate(prevProps) {
      //RedirectIfLogin();
    }

    componentWillUnmount(){
      UpdateState(this, 'message', '');
      UpdateState(this, 'password', '');
      UpdateState(this, 'password2', '');
      UpdateState(this, 'isAuthenticated', '');
      }
    
      PreloadDatas = async () => {
        let header = {
         headers : {
           'Accept': 'application/json',
           'Content-Type': "application/x-www-form-urlencoded",
           'Authorization': "Bearer " + name + ", Session " + name +", Platform "+ platform,
           'My-Custom-Header': name,
           'User-Agent': name+ " Bot",
        }
      };
      
        axios.get(ApiEndpoint+"/check_account/"+ getState(this, 'userID') +"/"+ getState(this, 'userToken'), '', header)
        .then(response => {
  

         if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.PreloadDatas();
              }, 4000);
             }
             }
           }

   
       if(response.data.error == false && response.data.error != true){
       
        if(response.data.isAuthenticated == 1){
       UpdateState(this, 'isAuthenticated', response.data.isAuthenticated);
       //UpdateState(this, 'message', '');
        }
        else{
          AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
        }
   
       }
       else if(response.data.error != false){
         AlertMessage(this, response.data.error, 'error');
         UpdateState(this, 'isAuthenticated', '0');
       }
       else{
         AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
       }
     }).catch(err => {
         AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
         this.PreloadDatas();
     });
       
     }
    
    AuthenticatedPreloading(){
      if(getState(this, 'isAuthenticated') == '' && getState(this, 'isAuthenticated') != '0' && getState(this, 'isAuthenticated') != '1'){
    return(
    <div className="preloadings">
      <div className="loading">
      <img src={loading} width="100px"/>
      <br/><br/><br/>
    </div>
      </div>
    );
      }
    }

    AuthenticatedFailed(){
    if(getState(this, 'isAuthenticated') == '0'){
    return(
    <>
    <div className="error">Invalid Token Credential Provided!</div>
<br/><br/>
    <div className="form-group-lg">
    
    <a href="/">
           <button className="btn btn-pink btn-link">GO TO HOME</button>
           </a>
           </div>
    </>
    );
    }
    }

    Authenticated(){
      if(getState(this, 'isAuthenticated') == '1'){
    return (
      <>
      <div className="form-group-lg">   
      <input type="text" className="form-input readonly" id="userID" placeholder="User ID"
      value={getState(this, 'userID')} readonly disabled/>
       </div>

       <div className="form-group-lg">   
      <input type="password" className="form-input" id="password" placeholder="New Password"
      onChange={(input) => UpdateState(this, "password", input.target.value) }/>
       </div>

       <div className="form-group-lg">   
      <input type="password" className="form-input" id="password2" placeholder="Confirm Password"
      onChange={(input) => UpdateState(this, "password2", input.target.value) }/>
       </div>

       <Button 
       wrapperClass="form-group-lg" 
       buttonClass="btn btn-blue btn-link" 
       buttonText="RESET PASSWORD"
       buttonAction="reset"
       self={this} />
       </>
    );
      }
    }

render() {
    return (
        <div className="App">
      <div className="body-wrapper" id="body-wrapper">
      <div className="form-first-child"> </div>
        <div className="form-wrapper">
      <div className="form-wrap-login">
        <div className="logo-wrap">
          <div className="logo-inner-wrap">
          <NavLink to="/">
            <img className="logo" src={logo} title={name + " Logo"} alt={name + " Logo"}/>
            </NavLink>
          </div>
          </div>
      <div className="form-inner-wrap">
      <div className="h1s">Reset Password </div>
       
       <BreedForm route="recover">
        
       {AlertMessageOut(this)}

        {this.AuthenticatedPreloading()}
        {this.Authenticated()}
        {this.AuthenticatedFailed()}

       </BreedForm>

       <div className="form-group-lg">
         <NavLink to="/">
       Didn't want to reset? Go to Home
       </NavLink>
       </div>
         </div>
        </div>
      </div>
      </div>

      <Footer/>
    </div>
    );
 }
}

export default Reset;